"use client";

import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import clsx from "clsx";
import type React from "react";
import { useState } from "react";

interface Props {
	children: React.ReactNode;
	className?: string;
	label: string;
	open?: boolean;
}

export default function Accordion({
	children,
	className,
	label,
	open = false,
}: Props) {
	const [isOpen, setIsOpen] = useState(open);
	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	return (
		<details
			{...setUserInteractionDataAttribute(
				`financial-education-accordion_${label.toLowerCase().replace(/\s/g, "_")}_details_summary_${isOpen ? "open" : "closed"}`,
			)}
			className={clsx("financial-education-accordion", className)}
			onToggle={handleToggle}
		>
			<summary className="financial-education-accordion__summary">
				<span className="financial-education-accordion__summary__text">
					{label}
				</span>
				<span className="financial-education-accordion__summary__icon">
					<FontAwesomeIcon
						icon={isOpen ? faCaretUp : faCaretDown}
						data-testid="financial-education-accordion-icon"
					/>
				</span>
			</summary>
			<div className="financial-education-accordion__content">{children}</div>
		</details>
	);
}
